<nav class="navbar navbar-expand-lg navbarBoxShadow">
  <div class="container">
    <a class="navbar-brand" href="javascript:void(0);" (click)="goToHome()">
      <img
        src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/instaciti-logo.png"
        class="img-fluid logoWidth"
        alt="instacity-logo"
      />
    </a>

    <a
      class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton mobileViewDisaplay align-self-center"
      target="_blank"
      href="http://join.instaciti.com/jff"
    >
      JOIN FOR FREE
    </a>
    <div
      class="collapse navbar-collapse desktopViewDisaplay"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item me-3 desktopViewDisaplay align-self-center">
          <a
            class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton"
            href="http://join.instaciti.com/jff"
            target="_blank"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-html="true"
            title='
                        <div>Sign Up now & get your free signature
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    '
          >
            JOIN FOR FREE
          </a>
        </li>
        <li class="nav-item customColor align-self-center">
          <a class="nav-link font16" href="#">Support | Login</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12 mt-4">
        <p class="font16 mutedColor textDecorationNone mb-0">
          <a href="javascript:void(0);" (click)="goToHome()">Home</a> /
          <a href="javascript:void(0);" (click)="goToEDU()"
            >Schools in {{ location }}
          </a>
          /
          <a class="schoolCustomColor font500">{{
            schoolDetails?.SchoolName
          }}</a>
        </p>
      </div>
      <div class="col-md-12">
        <div class="card border-0 schoolBoxShadow mt-4 mb-4">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-md-3">
                <!-- <ng-container *ngIf="schoolDetails && schoolDetails.LogoURL"> -->
                  <img
                    
                    [src]="schoolDetails && schoolDetails.LogoURL?schoolDetails.LogoURL:'https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png'"
                    class="img-fluid"
                    alt="logo"
                  />
                <!-- </ng-container> -->
                <img
                  *ngIf="!schoolDetails"
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png"
                  alt="businessImage"
                  class="img-fluid"
                />
              </div>
              <div class="col-md-9">
                <div class="row p-3">
                  <div class="col-10">
                    <h2>
                      {{ schoolDetails?.SchoolName }}
                      <img
                        src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/verified-icon.png"
                        class="img-fluid align-middle"
                        alt="circleIcon"
                      />
                    </h2>
                    <p class="font16 mutedColor mb-1 mt-1">
                      <i
                        class="fa-solid fa-location-dot me-3 schoolCustomColor"
                      ></i
                      >{{ schoolDetails.Address }}
                    </p>
                    <p class="font16 mutedColor mb-1 mt-1">
                      <i
                        class="fa-solid fa-book-open me-3 schoolCustomColor"
                      ></i
                      >{{ schoolDetails.ClassRange }}
                    </p>
                    <p class="font16 mutedColor mb-1 mt-1">
                      <i
                        class="fa-solid fa-user-graduate me-3 schoolCustomColor"
                      ></i
                      >{{ board }}
                    </p>
                    <p class="font16 mutedColor mb-1 mt-1">
                      <i
                        class="fa-solid fa-indian-rupee-sign me-3 schoolCustomColor"
                      ></i
                      >Avg. Monthly Fees: ₹ {{ schoolDetails.FeeRange }}
                    </p>
                    <p class="font16 mutedColor mb-1 mt-1 font500 greenText">
                      <i
                        class="fa-solid fa-id-card-clip me-3 schoolCustomColor"
                      ></i
                      >Admission Open
                    </p>
                  </div>
                  <div class="col-2 textDecorationNone text-end">
                    <a href="#" class="font16 font500 schoolCustomColor"
                      >Share <i class="fa-solid fa-share ms-2"></i
                    ></a>
                    <p>
                      <img
                        src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/instaciti-verified.png"
                        class="img-fluid mt-2"
                        alt="verified"
                      />
                    </p>
                  </div>
                </div>
                <div class="row ms-2 me-2 mb-4">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-3 mt-2">
                        <div class="card tagBoxShadow border-0">
                          <div class="card-body pt-2 pb-2">
                            <p class="mb-0 font14 font500 blackText">
                              <i
                                class="fa-regular fa-square schoolCustomColor font20 me-2 align-middle"
                              ></i>
                              Compare
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 mt-2">
                        <div class="card tagBoxShadow border-0">
                          <div class="card-body pt-2 pb-2">
                            <p class="mb-0 font14 font500 blackText">
                              <i
                                class="fa-solid fa-comments schoolCustomColor font20 me-2 align-middle"
                              ></i>
                              Ask A Question
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 mt-2">
                        <div class="card tagBoxShadow border-0">
                          <div class="card-body pt-2 pb-2">
                            <p class="mb-0 font14 font500 blackText">
                              <i
                                class="fa-solid fa-heart schoolCustomColor font20 me-2 align-middle"
                              ></i>
                              Shortlist
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 mt-2">
                        <div class="card tagBoxShadow border-0">
                          <div class="card-body pt-2 pb-2">
                            <p class="mb-0 font14 font500 blackText">
                              <i
                                class="fa-solid fa-bell schoolCustomColor font20 me-2 align-middle"
                              ></i>
                              Notify Me
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row p-1 border-top border-bottom">
          <div class="col-lg-1 col-md-2 col-3 p-1">
            <img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/gallery-placeholder.png"
              class="img-fluid"
              alt="student"
            />
          </div>
          <div class="col-lg-1 col-md-2 col-3 p-1">
            <div class="card border-0">
              <img
                src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/gallery-placeholder.png"
                class="img-fluid"
                alt="student"
              />
              <div class="card-img-overlay overlayBg text-center pt-4">
                <p class="font16 font600 schoolCustomColor">View more</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row border-bottom mb-5">
      <div class="col-md-2 border-end pe-0">
        <nav class="navbar sticky-top navbar-expand-lg">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 p-0">
                <p class="mt-4 mb-0 font20 headingBlackColor">ON THIS PAGE</p>
                <ul
                  class="list-group mt-2 font16 listDefaultText customListActive cursorPointer textDecorationNone"
                >
                  <li
                    class="list-group-item border-0 p-1 mt-1 mb-1"
                    aria-current="true"
                  >
                    <a
                      href="javascript:void(0);"
                      (click)="scrollToElement(OpenAdmissions)"
                      class="active"
                      >Open Admissions</a
                    >
                  </li>
                  <li class="list-group-item border-0 p-1 mt-1 mb-1">
                    <a
                      href="javascript:void(0);"
                      (click)="scrollToElement(AcademicStats)"
                      >Academic Stats</a
                    >
                  </li>
                  <li
                    *ngIf="schoolDetails.BriefIntro"
                    class="list-group-item border-0 p-1 mt-1 mb-1"
                  >
                    <a
                      href="javascript:void(0);"
                      (click)="scrollToElement(About)"
                      >About</a
                    >
                  </li>
                  <li class="list-group-item border-0 p-1 mt-1 mb-1">
                    <a
                      href="javascript:void(0);"
                      (click)="scrollToElement(AdmissionCriteria)"
                      >Admission Criteria</a
                    >
                  </li>
                  <li class="list-group-item border-0 p-1 mt-1 mb-1">
                    <a
                      href="javascript:void(0);"
                      (click)="scrollToElement(Amenities)"
                      >Amenities</a
                    >
                  </li>
                  <li class="list-group-item border-0 p-1 mt-1 mb-1">
                    <a
                      href="javascript:void(0);"
                      (click)="scrollToElement(AddressContact)"
                      >Address & Contact</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="col-md-10 mb-5">
        <div
          #OpenAdmissions
          class="card border-0 schoolBoxShadow borderRadius10 mt-4 pb-2"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="font500 schoolCustomColor">Open Admissions</h3>
              </div>
              <div class="col-md-3 textDecorationNone text-end redColor">
                <a href="#" class="font14"
                  ><i class="fa-regular fa-circle-question me-2"></i>How it
                  works?</a
                >
              </div>
              <div class="col-md-12 mt-3">
                <div class="row lightGreenBg ms-1 me-1 p-2 borderRadius5">
                  <div
                    [ngClass]="specialization.length ? 'col-md-3' : 'col-md-4'"
                  >
                    <p class="mb-0 font500">Select Session</p>
                  </div>
                  <div
                    [ngClass]="specialization.length ? 'col-md-3' : 'col-md-4'"
                  >
                    <p class="mb-0 font500">Select Class</p>
                  </div>
                  <div *ngIf="specialization.length" class="col-md-3">
                    <p class="mb-0 font500">Select Specialization</p>
                  </div>
                  <div
                    class="text-end"
                    [ngClass]="specialization.length ? 'col-md-3' : 'col-md-4'"
                  >
                    <p class="mb-0 font500">Action</p>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="mt-4 pe-5"
                    [ngClass]="specialization.length ? 'col-md-3' : 'col-md-4'"
                  >
                    <select
                      class="form-select customInput"
                      [(ngModel)]="selectedAcademic"
                      (change)="getSpecializationDetails()"
                    >
                      <option *ngFor="let acad of academics" [ngValue]="acad">
                        {{ acad.AcademicYear }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="mt-4 pe-5"
                    [ngClass]="specialization.length ? 'col-md-3' : 'col-md-4'"
                  >
                    <select
                      class="form-select customInput"
                      [(ngModel)]="selectedClass"
                      (change)="getSpecializationDetails()"
                    >
                      <option
                        *ngFor="let class of classes"
                        [value]="class.MasterClassID"
                      >
                        {{ class.Class }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="specialization.length" class="col-md-3 mt-4 pe-5">
                    <select
                      class="form-select customInput"
                      [(ngModel)]="selectedSpecialization"
                      (change)="getAcademicDetails()"
                    >
                      <option
                        *ngFor="let spec of specialization"
                        [value]="spec.SpecializationID"
                      >
                        {{ spec.Specialization }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="mt-4 text-end"
                    [ngClass]="specialization.length ? 'col-md-3' : 'col-md-4'"
                  >
                    <button
                      class="btn schoolCustomBg text-white ps-5 pe-4 borderRadius50 customInput"
                    >
                      Apply Now
                      <i class="fa-solid fa-angle-right text-end ms-3"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Last Date</p>
                    <h4
                      *ngIf="selectedAcademicDetails"
                      class="font20 schoolCustomColor mb-0"
                    >
                      {{ selectedAcademicDetails.ApplicationEndDate }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Application Fees</p>
                    <h4
                      *ngIf="selectedAcademicDetails"
                      class="font20 schoolCustomColor mb-0"
                    >
                      ₹ {{ selectedAcademicDetails.ApplicationFee }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          #AcademicStats
          class="card border-0 schoolBoxShadow borderRadius10 mt-4 pb-2"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h3 class="font500 schoolCustomColor mb-0">Academic Stats</h3>
                <div class="row">
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Classes Offered</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ schoolDetails.ClassRange }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Language of Instruction</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ languages }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Academic Session</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ selectedAcademic.AcademicYear }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Student Faculty Ratio</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ schoolDetails.StudentToTeacherRatio }}
                    </h4>
                    <p *ngIf="false" class="mb-0 blackText">
                      Delhi Ratio:
                      <span class="font18">{{
                        schoolDetails.StudentToTeacherRatio
                      }}</span>
                    </p>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Total Faculty</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ schoolDetails.NoOfTeachers }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">School Format</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ schoolDetails.ShiftFormat }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">School Timings</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ schoolDetails.OfficeTiming }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container #About>
          <div
            *ngIf="schoolDetails.BriefIntro"
            class="card border-0 schoolBoxShadow borderRadius10 mt-4 pb-2"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="font500 schoolCustomColor">About</h3>
                  <p class="font16 paraMuteText mb-2">
                    {{ schoolDetails.BriefIntro }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div
          #AdmissionCriteria
          class="card border-0 schoolBoxShadow borderRadius10 mt-4 pb-2"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h3 class="font500 schoolCustomColor">Admission Criteria</h3>
                <div class="row">
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">
                      Elegibility (Age Qualification)
                    </p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{selectedAcademicDetails}}
                      {{ selectedAcademicDetails?.AgeEligibility }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Written Test</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ selectedAcademicDetails?.WrittenTest }}
                    </h4>
                  </div>
                  <div class="col-md-4 mt-4">
                    <p class="paraMuteText mb-1">Parents Interaction</p>
                    <h4 class="font20 schoolCustomColor mb-0">
                      {{ selectedAcademicDetails?.ParentInterview }}
                    </h4>
                  </div>
                </div>
                <p class="font16 font500 headingBlack mt-3 mb-3">
                  Documents required at the time of admission/application
                </p>
                <div class="row mt-1">
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photo of Applicant
                    </p>
                  </div>
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photo of Applicant
                    </p>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photos of Parents/Guardian
                    </p>
                  </div>
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photos of Parents/Guardian
                    </p>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photos of Parents/Guardian
                    </p>
                  </div>
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photos of Parents/Guardian
                    </p>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photos of Parents/Guardian
                    </p>
                  </div>
                  <div class="col-md-4">
                    <p class="paraMuteText mb-1">
                      <i class="fa-solid fa-circle-check me-2 greenText"></i
                      >Photos of Parents/Guardian
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          #Amenities
          class="card border-0 schoolBoxShadow borderRadius10 mt-4 pb-2"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h3 class="font500 schoolCustomColor">Amenities</h3>
                <div class="row">
                  <div
                    *ngFor="let category of amenityCategories; let i = idx"
                    class="col-lg-3 col-md-6 mt-2 mb-2"
                  >
                    <p class="mb-2 font500 font16 headingBlack">
                      {{ category ? category : "School" }}
                    </p>
                    <ng-container *ngFor="let amenity of amenities">
                      <p
                        *ngIf="amenity.Grp === category"
                        class="paraMuteText mb-1"
                      >
                        <i class="fa-solid fa-circle-check me-2 greenText"></i
                        >{{ amenity.Attrib }}
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          #AddressContact
          class="card border-0 schoolBoxShadow borderRadius10 mt-4 pb-2"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h3 class="font500 schoolCustomColor mb-3 mt-2">
                  Address & Contact
                </h3>
                <div class="row mt-3">
                  <div class="col-auto pe-0">
                    <i
                      class="fa-solid fa-location-dot schoolCustomColor mt-1"
                    ></i>
                  </div>
                  <div class="col">
                    <p class="font16 headingBlack mb-0">
                      {{ schoolDetails.Address }}
                    </p>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-auto pe-0">
                    <i class="fa-solid fa-envelope schoolCustomColor mt-1"></i>
                  </div>
                  <div class="col">
                    <p class="font16 headingBlack mb-0">
                      {{ schoolDetails.EmailID }}
                    </p>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-auto pe-0">
                    <i class="fa-solid fa-globe schoolCustomColor mt-1"></i>
                  </div>
                  <div class="col">
                    <p class="font16 headingBlack mb-0">
                      <a [href]="schoolDetails.WebsiteURL" target="_blank">{{
                        schoolDetails.WebsiteURL
                      }}</a>
                    </p>
                  </div>
                </div>
              </div>
              <div
                *ngIf="schoolDetails.Latitude && schoolDetails.Longitude"
                class="col-md-6"
              >
                <agm-map
                  [latitude]="GetFloat(schoolDetails.Latitude)"
                  [longitude]="GetFloat(schoolDetails.Longitude)"
                  [zoom]="16"
                  [maxZoom]="20"
                >
                  <agm-marker
                    [latitude]="GetFloat(schoolDetails.Latitude)"
                    [longitude]="GetFloat(schoolDetails.Longitude)"
                    (mouseOver)="onMouseOver(infoWindow, $event)"
                    (mouseOut)="onMouseOut(infoWindow, $event)"
                  >
                    <agm-info-window [disableAutoPan]="false" #infoWindow>
                      <div class="cBranchName">
                        <i class="fa fa-building" aria-hidden="true"></i>
                        <span class="cBranchNameItem">{{
                          schoolDetails?.SchoolName
                        }}</span>
                      </div>
                      <div class="cBranchAddress">
                        <i class="fa fa-location-arrow" aria-hidden="true"></i>
                        <span class="cBranchAddressItem">{{
                          schoolDetails?.Address
                        }}</span>
                      </div>
                      <div class="cBranchPhone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <span class="cBranchPhoneItem">{{
                          schoolDetails?.MobileNumber
                        }}</span>
                      </div>
                    </agm-info-window>
                  </agm-marker>
                </agm-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngIf="true" class="col-md-12">
        <p class="font24 font500 schoolCustomColor">Nearby Schools</p>
        <div class="owl-slider">
          <div id="carousel" class="owl-carousel">
            <!-- <div class="owl-nav">
                      <button type="button" role="presentation" class="owl-prev">
                          <span aria-label="Previous"><i class="fa-solid fa-caret-left"></i></span>
                      </button>
                      <button type="button" role="presentation" class="owl-next">
                          <span aria-label="Next"><i class="fa-solid fa-caret-right"></i></span>
                      </button>
                  </div> -->
            <div
              *ngFor="let school of nearbySchools"
              class="item d-flex align-items-stretch"
            >
              <div
                class="card schoolBoxShadow border-0 borderRadius10 p-3 mt-2 mb-4"
              >
                <img
                  *ngIf="school.LogoURL"
                  [src]="school.LogoURL"
                  class="card-img-top"
                  alt="img"
                  (error)="school.LogoURL = null"
                />
                <img
                  *ngIf="!school.LogoURL"
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png"
                  alt="businessImage"
                  class="img-fluid"
                />
                <div class="card-body p-0 mt-2">
                  <p class="font18 headingBlackText font500 mb-2">
                    {{
                      school.BusinessTitle && school.BusinessTitle.length > 20
                        ? (school.BusinessTitle | slice: 0:18) + ".."
                        : school.BusinessTitle
                    }}
                  </p>
                  <p class="font14 colorMute">
                    <i
                      class="fa-solid fa-location-dot schoolCustomColor me-2"
                    ></i
                    >{{ school.Address }}
                  </p>
                </div>
                <div class="card-footer bg-white border-0 mt-2 p-0">
                  <button
                    class="btn redBg text-white"
                    (click)="openSchool(school.BusinessHandle)"
                  >
                    Apply Now<i
                      class="fa-solid fa-circle-chevron-right ms-2"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-4">
        <div
          class="card border-0 borderRadius10 greenFormBoxShadow negativecardMargin"
        >
          <div class="card-body p-3">
            <form>
              <div class="row">
                <div class="col-md-9">
                  <h5 class="font24 font500 customPurple">
                    List your business for FREE
                  </h5>
                  <div class="row">
                    <div class="col-md-4 mt-3">
                      <input
                        type="text"
                        class="form-control customInput borderRadius10 p-3"
                        placeholder="Your Name"
                      />
                    </div>
                    <div class="col-md-4 mt-3">
                      <input
                        type="text"
                        class="form-control customInput borderRadius10 p-3"
                        placeholder="Your Name"
                      />
                    </div>
                    <div class="col-md-4 mt-3">
                      <div class="d-grid">
                        <input
                          type="submit"
                          class="btn btn-sm p-2 orangeGradientButton borderRadius10 text-white p-3"
                          value="Contact Us"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <img
                    src="../../../../assets/instaciti-new-img/ctav 1.svg"
                    class="img-fluid negativeMargin"
                    alt="ctav"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<portal-instaciti-footer></portal-instaciti-footer>
